import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
import { isEmpty } from 'lodash';
import * as actions from '../../actions/index';
import './ProgressBar.scss';
import { RootState } from '../../reducers';
import { formatNumber } from '../../utils/react';
import ErrorContainer from '../ErrorContainer/ErrorContainer';
import TooltipComponent from './TooltipComponent';
import * as _actionsJourney2 from '../../actions/journey2';
import * as _actionsSearch from '../../actions/search';
import { TypeContainer } from '../../actions/typeContainer';

import { ReactComponent as LocationIcon } from '../../assets/icons/e_i_location.svg';
import { ReactComponent as IndustryIcon } from '../../assets/icons/e_i_sector.svg';
import { ReactComponent as PeriodIcon } from '../../assets/icons/e_i_period.svg';
import { ReactComponent as GreenTickIcon } from '../../assets/icons/new/green-tick.svg';
import { TITLES_BY_CATEGORY } from '../../containers/Summary';

import { ReactComponent as BasketIcon } from '../../assets/icons/new/basket.svg';
import { ReactComponent as FastbookIcon } from '../../assets/icons/new/fastbook.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/closeNew.svg';
import FastBookSearchInput from '../FastBookInput';
import { useParams } from 'react-router-dom';
import { useClickAway, useMedia, useScroll } from 'react-use';
import * as _actionsBasket from '../../actions/basket';
import { useNavigate } from 'react-router';
import { ListMapToggle } from '../ListMapToggle';
import ModalBackdrop from '../ModalBackdrop';
import { Transition } from 'react-transition-group';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface Props {
  actions: any;
  actionsJourney2: typeof _actionsJourney2;
  big5Industries: any;
  errors: Array<any>;
  filters: any;
  history: any;
  industries: any;
  industriesByKey: any;
  industry: any;
  intl: any;
  journeyType: string;
  keycloakReady?: boolean;
  locales: any;
  match: any;
  notices: Array<any>;
  possibleBookingDates: any;
  progress: number;
  stateStep6Loading: boolean;
  step: number;
  mapView: boolean;
  setMapView: any;
  subtitle: string;
  userDataEC: PartiallyIntegratedUserDataEC;
  dispatch: any;
  actionsBasket: typeof _actionsBasket;
  actionsSearch: typeof _actionsSearch;
  containers: TypeContainer;
}

const ProgressBar = (props: Props) => {
  const {
    userDataEC,
    filters,
    step,
    journeyType,
    subtitle,
    intl,
    big5Industries,
    industriesByKey,
    setMapView,
    mapView,
    errors,
    actionsBasket,
  } = props;

  const params = useParams();
  const rootScrollRef = React.useRef(document.getElementById('root'));
  const progressBarRef = React.useRef<HTMLDivElement>();
  const [isSticky, setIsSticky] = useState<boolean>(false);
  const [openFastbook, setOpenFastbook] = useState<boolean>(false);
  const isMobile = useMedia('(max-width: 768px)');
  const scrollPos = useScroll(rootScrollRef);
  const fastbookInputRef = React.useRef<HTMLDivElement>();
  const fastbookTriggerRef = React.useRef<HTMLDivElement>();
  useClickAway(fastbookInputRef, () => {
    setOpenFastbook(false);
  });
  const stepsWithoutBasket = [5, 6, '5', '6', 7, 8, 9, '7', '8', '9'];
  const navigate = useNavigate();

  //for integrated version: need to remove box shadow of topbar while progressbar is sticky
  const topBarRef = React.useRef(document.getElementsByClassName('top-navbar'));

  const handleScroll = () => {
    // We need this to make it work in the CMS-integrated version of the app because another solution doesn't work

    const position = window.scrollY;
    if (progressBarRef.current) {
      const elementRef = progressBarRef.current.getBoundingClientRect();
      if (elementRef && position >= (isMobile ? 214 : 297) - elementRef.height) {
        setIsSticky(true);
        removeTopBarBoxShadow(true);
      } else {
        setIsSticky(false);
        removeTopBarBoxShadow(false);
      }
    }
  };

  const removeTopBarBoxShadow = (flag: boolean = false) => {
    if (topBarRef && topBarRef.current.length > 0 && flag === true) {
      topBarRef.current[0].classList.add('shadow-none');
    }

    if (topBarRef && topBarRef.current.length > 0 && flag === false) {
      topBarRef.current[0].classList.remove('shadow-none');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (progressBarRef.current) {
      const elementRef = progressBarRef.current.getBoundingClientRect();
      if (elementRef && rootScrollRef.current.scrollTop >= (isMobile ? 214 : 297) - elementRef.height) {
        setIsSticky(true);
        removeTopBarBoxShadow(true);
      } else {
        setIsSticky(false);
        removeTopBarBoxShadow(false);
      }
    }
  }, [scrollPos.y]);

  const isStepActive = (step) => {
    const urlStep = params.step;
    return urlStep.toString() == step.toString();
  };

  const isStepCompleted = (step) => {
    const urlStep = params.step;

    if (journeyType === 'journey2' && !isEmpty(userDataEC.locations)) {
      return Number(step) <= 5;
    }

    return Number(step) <= Number(urlStep);
  };

  const handleSubPillClick = (step) => {
    const {
      journeyType,
      userDataEC: { locations },
    } = props;

    const renderOptions = renderPillContent(step, null, null);
    const isJourney2 = journeyType === 'journey2';
    const isJourney3 = journeyType === 'journey3';
    const isAccessTabOptionsJourney1 = renderOptions.hasContent && renderOptions.hasContent.length !== 0 && !isJourney2;
    const isAccessTabOptionsJourney2 = isJourney2 && !isEmpty(locations);
    const isAccessTabOptionsJourney3 = isJourney3 && !isEmpty(locations);

    if (renderOptions && (isAccessTabOptionsJourney1 || isAccessTabOptionsJourney2 || isAccessTabOptionsJourney3)) {
      navigate('/' + journeyType + '/' + step);
    }
  };

  const renderPillContent = (stepString, string, content) => {
    const step = Number(stepString);
    switch (step) {
      case 1: {
        const audience = userDataEC.audience;

        const formatedContent =
          audience === 'fixed'
            ? intl.formatMessage({
                id: 'ec.journey01.step01.audience1label',
                defaultMessage: 'Breites Publikum ansprechen',
              })
            : intl.formatMessage({
                id: 'ec.journey01.step01.audience2label',
                defaultMessage: 'Gezielt Personen ansprechen',
              });

        const locations = userDataEC.locations;

        const formatRadius = (radius) => {
          if (!!radius) {
            const a = radius / 1000;

            if (Math.floor(a) == 0) {
              return radius.toFixed(0) + ' m';
            }

            return Number(a.toFixed(1)) + ' km';
          }

          return null;
        };

        if (journeyType === 'journey1') {
          return {
            hasContent: audience,
            content: (
              <>
                <li>
                  <label>{formatedContent}</label>
                </li>
              </>
            ),
          };
        }

        if (journeyType === 'journey2' || journeyType === 'journey3') {
          const getRadius = (key) => formatRadius(locations[key]?.circle?.radius);
          const locationIds = [];
          const processedLocations = {};
          const locationStringSingular = intl.formatMessage({
            id: 'ec.journey02.flache',
            defaultMessage: 'Fläche',
          });
          const locationStringPlural = intl.formatMessage({
            id: 'ec.journey02.flachen',
            defaultMessage: 'Flächen',
          });
          for (const key in locations) {
            if (locations[key].context !== 'id') {
              processedLocations[key] = locations[key];
            } else {
              locationIds.push(key);
            }
          }
          const locationString = locationIds.length === 1 ? locationStringSingular : locationStringPlural;

          if (locationIds.length) {
            const locationsSum = `${locationIds.length} ${locationString}`;
            processedLocations[locationsSum] = {};
          }

          return {
            hasContent: true,
            content: Object.keys(processedLocations).map((locationKey) => {
              const radius = !locationKey.includes(locationString) ? getRadius(locationKey) : '';

              return (
                <li>
                  <label>
                    {unescape(locationKey)}
                    {radius ? `, ${radius}` : ''}
                  </label>
                </li>
              );
            }),
          };
        }

        break;
      }
      case 2: {
        const locations = userDataEC.locations;

        const formatRadius = (radius) => {
          if (!!radius) {
            const a = radius / 1000;

            if (Math.floor(a) == 0) {
              return radius.toFixed(0) + ' m';
            }

            return Number(a.toFixed(1)) + ' km';
          }

          return null;
        };
        if (journeyType === 'journey1')
          return {
            hasContent: Object.keys(locations).length !== 0,
            content: Object.keys(locations).map((locationKey) => (
              <li>
                <label>
                  {unescape(locationKey)}{' '}
                  {locations[locationKey].circle.radius && `, ` + formatRadius(locations[locationKey].circle.radius)}
                </label>
              </li>
            )),
          };
        const industry = userDataEC.industry;
        if (journeyType === 'journey2' || journeyType === 'journey3')
          return {
            hasContent: industry,
            content: (
              <li>
                <label>
                  {(industriesByKey && industriesByKey[industry] && industriesByKey[industry].value) ||
                    (big5Industries && big5Industries[industry] && big5Industries[industry].value)}
                </label>
              </li>
            ),
          };
        break;
      }
      case 3: {
        const budget = userDataEC.budget;
        if (journeyType === 'journey1') {
          return {
            hasContent: budget,
            content: !!budget ? (
              <li>
                <label>CHF {formatNumber(budget, 2)}</label>
              </li>
            ) : null,
          };
        }

        const duration = userDataEC.duration;
        const date = userDataEC.startDate;

        if (journeyType === 'journey2' || journeyType === 'journey3') {
          return {
            hasContent: true,
            content: date && duration && (
              <li>
                <label>
                  {format(Date.parse(date), 'dd-MM-yyyy', { locale: de })}, {duration}{' '}
                  <FormattedMessage id='ec.journey01.days' defaultMessage='Tage' />
                </label>
              </li>
            ),
          };
        }

        break;
      }
      case 4: {
        const industry = userDataEC.industry;

        if (journeyType === 'journey1') {
          return {
            hasContent: industry,
            content: (
              <li>
                <label>
                  {(industriesByKey && industriesByKey[industry] && industriesByKey[industry].value) ||
                    (big5Industries && big5Industries[industry] && big5Industries[industry].value)}
                </label>
              </li>
            ),
          };
        }

        const attributes = userDataEC.attribute;
        const formats = userDataEC.format;
        const both = attributes && formats;
        const attributeByKey = filters ? filters.attributeByKey : '';

        if (journeyType === 'journey2' || journeyType === 'journey3') {
          return {
            // @ts-expect-error from any to string[] this is wrong:
            hasContent: attributes | formats | both,
            content:
              formats || attributes
                ? [
                    formats &&
                      formats.map((format) => (
                        <li>
                          <label>{format}</label>
                        </li>
                      )),
                    attributes &&
                      attributes.map((attribute) => (
                        <li>
                          <label>{attributeByKey ? attributeByKey[attribute].value : attribute}</label>
                        </li>
                      )),
                  ]
                : null,
          };
        }

        break;
      }
      case 5: {
        const duration = userDataEC.duration;
        const date = userDataEC.startDate;
        if (journeyType === 'journey1')
          return {
            hasContent: true,
            content: date && duration && (
              <li>
                <label>
                  {format(Date.parse(date), 'dd-MM-yyyy', { locale: de })}, {duration}{' '}
                  <FormattedMessage id='ec.journey01.days' defaultMessage='Tage' />
                </label>
              </li>
            ),
          };
        const targets = userDataEC.target;
        const targetByKey = filters?.targetByKey;

        if (journeyType === 'journey2' || journeyType === 'journey3')
          return {
            hasContent: targets,
            content:
              targets &&
              targets.length > 0 &&
              targets.map((targetId) => (
                <li>
                  <label>
                    {targetByKey && targetByKey[targetId] && targetByKey[targetId].value
                      ? targetByKey[targetId].value
                      : null}
                  </label>
                </li>
              )),
          };
        break;
      }
      case 6: {
        const digital = userDataEC.digital;
        let content = [];

        if (digital === 0) {
          content.push(<FormattedMessage id='ec.navigation.analogeWerbemittel' defaultMessage='Analoge Werbeträger' />);
        } else if (digital === 1) {
          content.push(
            <FormattedMessage id='ec.navigation.digitaleWerbemittel' defaultMessage='Digitale Werbeträger' />,
          );
        } else {
          content.push(<FormattedMessage id='ec.navigation.analogeWerbemittel' defaultMessage='Analoge Werbeträger' />);
          content.push(
            <FormattedMessage id='ec.navigation.digitaleWerbemittel' defaultMessage='Digitale Werbeträger' />,
          );
        }

        if (journeyType === 'journey1')
          return {
            hasContent: digital,
            content: content.map((text) => (
              <li>
                <label>{text}</label>
              </li>
            )),
          };
        break;
      }
      case 7: {
        break;
      }
    }
  };

  const isExistContent = (key: string) => {
    if (userDataEC && userDataEC[key]) {
      if (key === 'locations') {
        return Object.keys(userDataEC[key]).length;
      }

      if ((key === 'format' || key === 'target' || key === 'attribute') && Array.isArray(userDataEC[key])) {
        return userDataEC[key].length;
      }

      return 1;
    }

    return false;
  };

  const formatDate = (date: Date | string) => {
    const parsedDate = typeof date === 'string' ? parseISO(date) : Date.parse(String(date));

    return parsedDate ? format(parsedDate, 'dd.MM.yyyy', { locale: de }) : '';
  };

  const existContent = (key: string) => {
    if (userDataEC && userDataEC[key]) {
      if (key === 'locations') {
        return (
          <div className='d-flex locations-pills'>
            {Object.keys(userDataEC[key]).map((loc) => {
              return <p className='m-0 '>{unescape(loc)},&nbsp;</p>;
            })}
          </div>
        );
      }

      if (key === 'budget') {
        return Number(userDataEC[key]) + '.-';
      }

      if ((key === 'format' || key === 'target' || key === 'attribute') && Array.isArray(userDataEC[key])) {
        return userDataEC[key];
      }

      if (key === 'startDate') {
        return formatDate(userDataEC[key]);
      }

      if (key === 'duration') {
        return userDataEC[key];
      }

      return 1;
    }

    return false;
  };

  const renderJ1ProgressBar = () => {
    const countLocations = existContent('locations');
    const chooseBudget = existContent('budget');
    const chooseStartDate = existContent('startDate');
    const chooseDuration = existContent('duration');

    return (
      <div className='subSteps-v2'>
        <TooltipComponent
          key='tooltip1j1'
          renderPillContent={!!renderPillContent ? renderPillContent : null}
          step={1}
          active={isStepActive(1)}
          completed={isStepCompleted(1)}
        >
          <div
            className={classNames('subPill-v2', {
              active: isStepActive(1),
              completed: isStepCompleted(1),
            })}
            onClick={() => handleSubPillClick(1)}
          >
            <>
              <div className='label'>
                <FormattedMessage id='ec.journey01.target' defaultMessage='Ziele' />
              </div>
              <div className='value'>
                <FormattedMessage id='ec.journey01.target' defaultMessage='Ziele' />
              </div>
            </>
          </div>
        </TooltipComponent>

        <TooltipComponent
          step={2}
          key='tooltip2j1'
          renderPillContent={renderPillContent}
          active={isStepActive(2)}
          completed={isStepCompleted(2)}
        >
          <div
            className={classNames('subPill-v2', {
              active: isStepActive(2),
              completed: isStepCompleted(2),
            })}
            onClick={() => handleSubPillClick(2)}
          >
            <>
              <div className='label'>
                <FormattedMessage id='ec.journey01.city' defaultMessage='Ort' />
              </div>
              <div className='value'>
                {/* @ts-expect-error mitmatch on extracting types values, was typed as any before */}
                {countLocations.props.children.length > 0 ? (
                  countLocations
                ) : (
                  <FormattedMessage id='ec.journey01.city' defaultMessage='Ort' />
                )}
              </div>
            </>
          </div>
        </TooltipComponent>

        <TooltipComponent
          step={3}
          renderPillContent={renderPillContent}
          key='tooltip3j1'
          active={isStepActive(3)}
          completed={isStepCompleted(3)}
        >
          <div
            className={classNames('subPill-v2', {
              active: isStepActive(3),
              completed: isStepCompleted(3),
            })}
            onClick={() => handleSubPillClick(3)}
          >
            <>
              <div className='label'>
                <FormattedMessage id='ec.journey01.budget' defaultMessage='Budget' />
              </div>
              <div className='value'>
                {!!chooseBudget ? chooseBudget : <FormattedMessage id='ec.journey01.budget' defaultMessage='Budget' />}
              </div>
            </>
          </div>
        </TooltipComponent>

        <TooltipComponent
          step={4}
          renderPillContent={renderPillContent}
          key='tooltip4j1'
          active={isStepActive(4)}
          completed={isStepCompleted(4)}
        >
          <div
            className={classNames('subPill-v2', {
              active: isStepActive(4),
              completed: isStepCompleted(4),
            })}
            onClick={() => handleSubPillClick(4)}
          >
            <>
              <div className='label'>
                <FormattedMessage id='ec.journey01.message' defaultMessage='Botschaft' />
              </div>
              <div className='value'>
                <FormattedMessage id='ec.journey01.message' defaultMessage='Botschaft' />
              </div>
            </>
          </div>
        </TooltipComponent>

        <TooltipComponent
          step={5}
          renderPillContent={renderPillContent}
          key='tooltip5j1'
          active={isStepActive(5)}
          completed={isStepCompleted(5)}
        >
          <div
            className={classNames('subPill-v2', {
              active: isStepActive(5),
              completed: isStepCompleted(5),
            })}
            onClick={() => handleSubPillClick(5)}
          >
            <>
              <div className='label'>
                <FormattedMessage id='ec.journey01.time' defaultMessage='Zeit' />
              </div>
              <div className='value'>
                {!!chooseStartDate ? (
                  `${chooseStartDate}/${chooseDuration} ${intl.formatMessage({
                    id: 'ec.journey1.tage',
                    defaultMessage: 'Tage',
                  })}`
                ) : (
                  <FormattedMessage id='ec.journey01.time' defaultMessage='Zeit' />
                )}
              </div>
            </>
          </div>
        </TooltipComponent>

        <TooltipComponent
          step={6}
          renderPillContent={renderPillContent}
          key='tooltip6j1'
          active={isStepActive(6)}
          completed={isStepCompleted(6)}
        >
          <div
            className={classNames('subPill-v2', {
              active: isStepActive(6),
              completed: isStepCompleted(6),
            })}
            onClick={() => handleSubPillClick(6)}
          >
            <div className='label'>
              <FormattedMessage id='ec.journey01.material' defaultMessage='Werbeträger' />
            </div>
            <div className='value'>
              <FormattedMessage id='ec.journey01.material' defaultMessage='Werbeträger' />
            </div>
          </div>
        </TooltipComponent>
      </div>
    );
  };

  const renderJ2ProgressBar = () => {
    const countLocations = isExistContent('locations');
    const chooseIndustry = isExistContent('industry');
    const chooseDate = isExistContent('duration');

    return (
      <>
        {isSticky && <div className='fix-spacing' />}
        <div
          ref={progressBarRef}
          className={classNames('subSteps justify-content-between', {
            isSticky: isSticky,
          })}
        >
          <div className={`d-flex ${!isSticky && 'p-2-5'} align-items-center`}>
            <TooltipComponent
              step={1}
              key='tooltip1'
              renderPillContent={renderPillContent}
              active={isStepActive(1)}
              completed={isStepCompleted(1)}
            >
              <div
                className={classNames('subPill', {
                  active: isStepActive(1),
                  completed: isStepCompleted(1),
                })}
                onClick={() => handleSubPillClick(1)}
              >
                <LocationIcon />
                <>
                  <div className='label'>
                    <FormattedMessage id='ec.journey02.step01.targetAreas' defaultMessage='Zielgebiete' />
                  </div>
                  <div className='value'>
                    <FormattedMessage id='ec.journey02.step01.targetAreas' defaultMessage='Zielgebiete' />
                  </div>
                </>

                {!!countLocations && <span>: {countLocations}</span>}
              </div>
            </TooltipComponent>

            <TooltipComponent
              step={2}
              key='tooltip2'
              renderPillContent={renderPillContent}
              active={isStepActive(2)}
              completed={isStepCompleted(2)}
            >
              <div
                className={classNames('subPill', {
                  active: isStepActive(2),
                  completed: isStepCompleted(2),
                  hasError:
                    ('1002_App\\Shop\\Domain\\Exception\\BasketValidationException' in errors &&
                      !userDataEC.industry) ||
                    '1003_App\\Shop\\Domain\\Exception\\BasketValidationException' in errors,
                })}
                onClick={() => handleSubPillClick(2)}
              >
                <IndustryIcon />
                <>
                  <div className='label'>
                    <FormattedMessage id='ec.summary.branche' defaultMessage='Branche' />
                  </div>
                  <div className='value'>
                    <FormattedMessage id='ec.summary.branche' defaultMessage='Branche' />
                  </div>
                </>

                {!!chooseIndustry && <span>: {chooseIndustry}</span>}
              </div>
            </TooltipComponent>

            <TooltipComponent
              step={3}
              key='tooltip3'
              renderPillContent={renderPillContent}
              active={isStepActive(3)}
              completed={isStepCompleted(3)}
            >
              <div
                className={classNames('subPill', {
                  active: isStepActive(3),
                  completed: isStepCompleted(3),
                  hasError:
                    '1002_App\\Shop\\Domain\\Exception\\BasketValidationException' in errors ||
                    '1003_App\\Shop\\Domain\\Exception\\BasketValidationException' in errors,
                })}
                onClick={() => handleSubPillClick(3)}
              >
                <PeriodIcon />
                <>
                  <div className='label'>
                    <FormattedMessage id='ec.journey02.time' defaultMessage='Zeitraum' />
                  </div>
                  <div className='value'>
                    <FormattedMessage id='ec.journey02.time' defaultMessage='Zeitraum' />
                  </div>
                </>

                {!!chooseDate && <span>: {chooseDate}</span>}
              </div>
            </TooltipComponent>
          </div>

          {!isMobile && !isSticky && <FastBookSearchInput />}

          {!isMobile && isSticky && (
            <div className='d-flex align-items-center justify-content-end gap-5'>
              {step == 4 && <ListMapToggle setMapView={setMapView} mapView={mapView} />}
              {!stepsWithoutBasket.includes(step) && getBasket()}
            </div>
          )}
        </div>
      </>
    );
  };

  const getTitle = (step: number, isJourney1: boolean = false) => {
    let pill = 0;

    if ((step >= 1 && step <= 6 && isJourney1) || (step >= 1 && step <= 5 && !isJourney1)) {
      pill = 1;
    }

    if ((step === 7 && isJourney1) || (step === 6 && !isJourney1)) {
      pill = 2;
    }

    if (step === 7) {
      pill = 3;
    }

    if (step === 8) {
      pill = 4;
    }

    if (step === 9) {
      pill = 5;
    }

    if (step > 100) {
      pill = 6;
    }

    switch (pill) {
      case 1:
        return intl.formatMessage({
          id: 'ec.navigation.objectives',
          defaultMessage: 'Planung',
        });
      case 2:
        return intl.formatMessage({
          id: 'ec.navigation.proposal',
          defaultMessage: 'Flächenauswahl',
        });
      case 3:
        return userDataEC.isAgency
          ? intl.formatMessage({
              id: 'ec.navigation.designAndProductionAgency',
              defaultMessage: 'Werbekampagne & Kundenauswahl',
            })
          : intl.formatMessage({
              id: 'ec.navigation.designAndProduction',
              defaultMessage: 'Gestaltung & Produktion',
            });
      case 4:
        return props.userDataEC.basketInfo
          ? TITLES_BY_CATEGORY[props.userDataEC.basketInfo.category && 1]
          : TITLES_BY_CATEGORY[1];
      case 5:
        return intl.formatMessage({
          id: 'ec.navigation.confirmation',
          defaultMessage: 'Bestätigung',
        });
      case 6:
        return intl.formatMessage({
          id: 'ec.navigation.copyCampaign',
          defaultMessage: 'Kampagne nochmals buchen',
        });
      default:
        return intl.formatMessage({
          id: 'ec.journey01.empfehlung',
          defaultMessage: 'Werbeflächen auswählen',
        });
    }
  };

  const getBasket = () => {
    return (
      <div
        className='basket-trigger d-flex flex-row'
        id={'basket-trigger'}
        style={{ zIndex: 997 }}
        onClick={() => actionsBasket.openBasket()}
      >
        <div className='basket-trigger-container'>
          <BasketIcon className={'basket-trigger-icon'} />
          {userDataEC.basketProducts.stats?.totalcount > 0 && (
            <span className='mediaCount'>{userDataEC.basketProducts?.stats?.totalcount}</span>
          )}
        </div>
        {userDataEC.basketProducts.stats?.totalcount > 0 && (
          <div className='basket-total-info'>
            <b className={'font-20'}>CHF {userDataEC.basketProducts.stats?.mediasum}</b>
            <div className={'font-14 text-grey-light'}>
              {userDataEC.basketProducts.stats?.totalcount}{' '}
              {userDataEC.basketProducts.stats?.totalcount === 1 ? (
                <FormattedMessage id='ec.product' defaultMessage='Produkt' />
              ) : (
                <FormattedMessage id='ec.products' defaultMessage='Produkte' />
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const getTopPosition = () => {
    if (fastbookTriggerRef) {
      const el = fastbookTriggerRef?.current.getBoundingClientRect();
      return 40 + el.top;
    }
    return 220;
  };

  return (
    <div
      className={classNames({
        progressBarV2: journeyType === 'journey1' || journeyType === 'journey3',
        progressBar: journeyType === 'journey2',
      })}
    >
      <div className='header d-flex justify-content-between align-items-center'>
        <h4>{getTitle(step, journeyType === 'journey1')}</h4>

        <div className='d-flex align-items-center justify-content-end gap-4'>
          {journeyType === 'journey2' && (
            <div className='fastbook-trigger'>
              <div
                className={classNames('fastbook-trigger-container', { opened: openFastbook })}
                ref={fastbookTriggerRef}
                onClick={() => setOpenFastbook(!openFastbook)}
              >
                {!openFastbook && <FastbookIcon className={'fastbook-open-icon'} />}
                {openFastbook && <CloseIcon className={'fastbook-close-icon'} />}
              </div>
              <Transition in={openFastbook} timeout={50}>
                {(state) => (
                  <ModalBackdrop duration={250} state={state}>
                    {openFastbook && (
                      <div className='fastbook-popup' style={{ top: getTopPosition() }} ref={fastbookInputRef}>
                        <FastBookSearchInput />
                      </div>
                    )}
                  </ModalBackdrop>
                )}
              </Transition>
            </div>
          )}

          {!stepsWithoutBasket.includes(step) && getBasket()}
        </div>
      </div>

      {journeyType === 'journey3' && subtitle && <h5>{subtitle}</h5>}

      {journeyType === 'journey1' ? (
        <div
          className={classNames('steps mt-24 d-flex w-100 ms-0', {
            perc10: step == 1,
            perc20: step == 2,
            perc30: step == 3,
            perc40: step == 4,
            perc50: step == 5,
            perc60: step == 6,
            perc70: step == 7,
            perc80: step == 8 && !userDataEC.isAgency,
            'perc80-agency': step == 8 && userDataEC.isAgency,
            perc100: step == 8 && !userDataEC.isAgency,
            'perc100-agency': step == 9 && userDataEC.isAgency,
          })}
        >
          <div
            className={classNames('step-v2 ms-0', {
              active: step >= 1,
              current: step < 7,
            })}
          >
            {step >= 7 ? <GreenTickIcon className='me-3' /> : <div className='pill'>1</div>}
            <p>
              <FormattedMessage id='ec.navigation.objectives' defaultMessage='Planung' />
            </p>
          </div>

          <div
            className={classNames('step-v2', {
              active: step >= 7,
              current: step <= 7,
            })}
          >
            {step >= 8 ? <GreenTickIcon className='me-3' /> : <div className='pill'>2</div>}
            <p>
              <FormattedMessage id='ec.navigation.proposal' defaultMessage='Flächenauswahl' />
            </p>
          </div>

          {/*<div*/}
          {/*    className={classNames('step-v2', {*/}
          {/*        active: step >= 7,*/}
          {/*        current: step <= 7,*/}
          {/*    })}*/}
          {/*>*/}
          {/*    {step > 7 ? <GreenTickIcon className="me-3" /> : <div className="pill">5</div>}*/}
          {/*    <p>*/}
          {/*        {userDataEC.isAgency ? (*/}
          {/*            <FormattedMessage*/}
          {/*                id="ec.navigation.designAndProductionAgency"*/}
          {/*                defaultMessage="Werbekampagne & Kundenauswahl"*/}
          {/*            />*/}
          {/*        ) : (*/}
          {/*            <FormattedMessage*/}
          {/*                id="ec.navigation.designAndProduction"*/}
          {/*                defaultMessage="Gestaltung & Produktion"*/}
          {/*            />*/}
          {/*        )}*/}
          {/*    </p>*/}
          {/*</div>*/}

          <div
            className={classNames('step-v2', {
              active: step >= 8,
              current: step <= 8,
            })}
          >
            {step > 8 ? <GreenTickIcon className='me-3' /> : <div className='pill'>4</div>}

            <p>
              <FormattedMessage id='ec.navigation.payment' defaultMessage='Zahlung' />
            </p>
          </div>

          <div
            className={classNames('step-v2', {
              active: step >= 9,
              current: step <= 9,
            })}
          >
            <div className='pill'>
              <GreenTickIcon className='green-tick' />
            </div>
            <p>
              <FormattedMessage id='ec.navigation.confirmation' defaultMessage='Bestätigung' />
            </p>
          </div>
        </div>
      ) : (
        <div
          className={classNames('steps mt-24 row w-100 ms-0', {
            perc10: step == 1,
            perc20: step == 2,
            perc40: step == 3,
            perc60: step == 4 && !userDataEC.isAgency,
            'perc60-agency': step == 4 && userDataEC.isAgency,
            perc70: step == 5 && !userDataEC.isAgency,
            'perc70-agency': step == 5 && userDataEC.isAgency,
            perc100: step == 6 && !userDataEC.isAgency,
            'perc100-agency': step == 6 && userDataEC.isAgency,
          })}
        >
          <div
            className={classNames('step-v2 col ms-0', {
              active: step >= 1,
              current: step <= 2,
            })}
          >
            <div className='d-flex align-items-center justify-content-center'>
              {step > 2 ? <GreenTickIcon className='me-3' /> : <div className='pill'>1</div>}
              <p>
                <FormattedMessage id='ec.navigation.objectives' defaultMessage='Planung' />
              </p>
            </div>
          </div>

          <div
            className={classNames('step-v2 col', {
              active: step >= 3,
              current: step <= 3,
            })}
          >
            <div className='d-flex align-items-center justify-content-center'>
              {step > 3 ? <GreenTickIcon className='me-3' /> : <div className='pill'>2</div>}
              <p>
                <FormattedMessage id='ec.navigation.proposal' defaultMessage='Flächenauswahl' />
              </p>
            </div>
          </div>

          <div
            className={classNames('step-v2 col', {
              active: step >= 4,
              current: step <= 4,
            })}
          >
            <div className='d-flex align-items-center justify-content-center'>
              {step > 4 ? <GreenTickIcon className='me-3' /> : <div className='pill'>3</div>}
              <p>
                {props.userDataEC.basketInfo
                  ? TITLES_BY_CATEGORY[props.userDataEC.basketInfo.category || 1]
                  : TITLES_BY_CATEGORY[1]}
              </p>
            </div>
          </div>

          <div
            className={classNames('step-v2 col', {
              active: step >= 5,
              current: step <= 5,
            })}
          >
            <div className='d-flex align-items-center justify-content-center'>
              {step >= 6 ? <GreenTickIcon className='me-3' /> : <div className='pill'>4</div>}
              <p>
                <FormattedMessage id='ec.navigation.confirmation' defaultMessage='Bestätigung' />
              </p>
            </div>
          </div>
        </div>
      )}

      {step < 8 && journeyType === 'journey1' && renderJ1ProgressBar()}
      {step < 5 && (journeyType === 'journey2' || journeyType === 'journey3') && renderJ2ProgressBar()}

      {(step === 6 && journeyType === 'journey2') || (step === 10 && journeyType === 'journey1') ? (
        <></>
      ) : (
        <ErrorContainer journeyType={journeyType} />
      )}
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actions: bindActionCreators(actions as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsSearch: bindActionCreators(_actionsSearch as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProgressBar)));
